import React from 'react';

// Filet de sécurité global : tout crash de rendu est rattrapé ici et affiche
// un message récupérable au lieu d'un écran noir/blanc figé.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('💥 Erreur de rendu rattrapée par ErrorBoundary:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#f8fafc', padding: '24px', fontFamily: 'system-ui, sans-serif'
        }}>
          <div style={{
            maxWidth: '480px', width: '100%', background: '#fff', borderRadius: '16px',
            padding: '32px', boxShadow: '0 10px 40px rgba(0,0,0,0.12)', textAlign: 'center'
          }}>
            <div style={{ fontSize: '42px', marginBottom: '8px' }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px', color: '#111827' }}>Une erreur est survenue</h2>
            <p style={{ color: '#6b7280', margin: '0 0 20px', fontSize: '14px' }}>
              L'affichage a rencontré un problème. Vos données ne sont pas perdues.
              Cliquez ci-dessous pour réessayer.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button onClick={this.handleReset} style={{
                background: '#4f46e5', color: '#fff', border: 'none', padding: '10px 20px',
                borderRadius: '8px', cursor: 'pointer', fontWeight: 600
              }}>Réessayer</button>
              <button onClick={() => window.location.reload()} style={{
                background: '#e5e7eb', color: '#374151', border: 'none', padding: '10px 20px',
                borderRadius: '8px', cursor: 'pointer', fontWeight: 600
              }}>Recharger la page</button>
            </div>
            {this.state.error && (
              <pre style={{
                marginTop: '18px', textAlign: 'left', background: '#f3f4f6', padding: '12px',
                borderRadius: '8px', fontSize: '12px', color: '#b91c1c', overflowX: 'auto', whiteSpace: 'pre-wrap'
              }}>{String(this.state.error.message || this.state.error)}</pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
